import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { RouterService } from 'src/app/services/router-service.service';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {

	constructor(private auth:AuthService,
				private routerService:RouterService) {
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : boolean {
		if (this.auth.isLoggedIn()) {
			return true;
		} else {
			this.routerService.toLogin(state.url);
			return false;
		}
	}
}
